import {
  PLATES,
  GET_PLATES,
  GET_PLATES_ERROR,
  GET_PLATES_SUCCESS,
  ASSIGN_PLATE_MUKEB_SUCCESS,
  ASSIGN_PLATE_MUKEB_ERROR,
  CANCEL_PLATE_SUCCESS,
  CANCEL_PLATE_ERROR,
  ASSIGN_PLATE_MUKEB,
  CANCEL_PLATE,
  EXPORT_PLATES_EXCEL,
  EXPORT_PLATES_EXCEL_SUCCESS,
  EXPORT_PLATES_EXCEL_ERROR,
} from 'redux/actions';

const initialStates = {
  plates: [],
  loading: false,
  error: '',
  success: '',
};

export default (state = initialStates, action) => {
  switch (action.type) {
    case GET_PLATES:
    case ASSIGN_PLATE_MUKEB:
    case CANCEL_PLATE:
    case EXPORT_PLATES_EXCEL:
      return {
        ...state,
        loading: true,
        success: '',
        error: '',
      };
    case PLATES:
      return {
        ...state,
        plates: action.payload.plates,
      };
    case GET_PLATES_SUCCESS:
    case ASSIGN_PLATE_MUKEB_SUCCESS:
    case CANCEL_PLATE_SUCCESS:
    case EXPORT_PLATES_EXCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: action.payload.message,
      };
    case GET_PLATES_ERROR:
    case ASSIGN_PLATE_MUKEB_ERROR:
    case CANCEL_PLATE_ERROR:
    case EXPORT_PLATES_EXCEL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        success: '',
      };
    default:
      return state;
  }
};
